import { compose } from 'redux'

// higher-order components
import withRedux from './withRedux'
import withState from './withState'
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'
import withFormResults from 'components/shared/withFormResults'

// presentational component
import UI from './UI'

const withValidationResults = withFormResults({
  mutation: 'validateRedeemablePass',
  field: 'redeemablePass'
})

export default compose(
  withRedux, // for setting error state
  withState, // for getting/setting guest pass code
  withValidationResults,
  withMutation, // for fetching account data
  withEventHandlers // for UI interactions
)(UI)
